// extracted by mini-css-extract-plugin
export var box = "_53-1";
export var checkboxRow = "_53-8";
export var checked = "_53-2";
export var descriptionSpacer = "_53-a";
export var disabled = "_53-3";
export var icon = "_53-6";
export var input = "_53-0";
export var labelSpacer = "_53-9";
export var medium = "_53-5";
export var small = "_53-4";
export var text = "_53-7";